"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _syncFeaturedPresenter = _interopRequireDefault(require("../../../actions/program/syncFeaturedPresenter"));
var _actionUtils = require("../../../utils/actionUtils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function presenterFeatured(_ref, _ref2) {
  var dispatch = _ref.dispatch,
    getState = _ref.getState;
  var notifyingDirector = _ref2.notifyingDirector,
    presenterId = _ref2.presenterId;
  if (!(0, _actionUtils.isSameAttendee)(notifyingDirector, getState())) {
    dispatch((0, _syncFeaturedPresenter["default"])(presenterId));
  }
}
var _default = exports["default"] = presenterFeatured;